<template>
  <div class="about">
    <h1 style="margin-bottom: 15px;">Суть</h1>
      <p>
        В данном тестовом задании требовалось сверстать веб-приложение
        на основе базы кафе, используя фреймворк Vue. В приложении должна быть возможность видеть все кафе + 
        возможность рандомного выбора кафе. Нужен адаптив с десктопа до мобильного устройства. Должны быть кнопки "поделиться" 
        От себя добавил поиск по названию кафе и возможность просмотра полной информации конкретного кафе
      </p>
  </div>
</template>
<style scoped>
.about{
  max-width: 500px;
  line-height:24px;
  padding: 2%;
  margin-right: auto;
  margin-left: auto;
}
</style>